import React from 'react'
import './Icon.scss'
const rootClassName = 'icon-component'

export const ArrowLeftIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M2.73367 12.75L9.7467 18.9376C10.0573 19.2117 10.0869 19.6856 9.81289 19.9962C9.53885 20.3068 9.0649 20.3364 8.7543 20.0624L0.253801 12.5624C-0.0778217 12.2698 -0.085576 11.7553 0.237079 11.4528L8.23808 3.95282C8.54028 3.66954 9.01491 3.68488 9.29819 3.98708C9.58146 4.28928 9.56612 4.76391 9.26392 5.04719L2.64676 11.25H23.25C23.6642 11.25 24 11.5858 24 12C24 12.4142 23.6642 12.75 23.25 12.75H2.73367Z' />
    </svg>
  )
}
